import React from 'react';
import { Alert, Typography } from '@mui/material';

export interface FormErrorSummaryProps {
  messages: string[];
  title?: string;
}

export const FormErrorSummary: React.FC<FormErrorSummaryProps> = ({
  messages,
  title,
}) => {
  const unique = Array.from(new Set(messages.filter(Boolean)));
  if (unique.length === 0) return null;

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {title || `Please fix ${unique.length} issue${unique.length === 1 ? '' : 's'}:`}
      </Typography>
      <Typography component="ul" variant="body2" sx={{ m: 0, pl: 2.5 }}>
        {unique.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </Typography>
    </Alert>
  );
};

export default FormErrorSummary;
